import React, { Component } from "react";
import { Link } from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <button
          onClick={() => {
            window.location.reload();
          }}
        >
          Something went wrong, click to view the product
        </button>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
